import axios from "@/plugins/axios";
// import * as example from "./example";

let url = "/api/v1/shop/products";

export const inquires = {
    // ...example,
    gets(_product, data){
        return axios.get(`${url}/${_product}/inquires`, data).then(result => result.data);
    },
    post(_product, data){
        return axios.post(`${url}/${_product}/inquires`, data).then(result => result.data);
    },
    put(_product, data){
        return axios.put(`${url}/${_product}/inquires/${data._id}`, data).then(result => result.data);
    },
    delete(_product, data){
        return axios.delete(`${url}/${_product}/inquires/${data._id}`).then(result => result.data);
    }
}
